import { Loading } from "best-common-react";
import React, { lazy, Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { useUser } from "./contexts/UserContext";
import { isOAuthCallbackInProgress } from "./utils/OktaAuthUtil";

const AuthenticatedApp = lazy(() => import("./AuthenticatedApp"));
const UnauthenticatedApp = lazy(() => import("./UnauthenticatedApp"));

const App = () => {
  const { hasUserInfo } = useUser();
  // Stay on the unauthenticated tree during /login/callback so LoginCallback is not
  // unmounted/remounted (which would call handleLoginRedirect twice and lose the PKCE verifier).
  const showAuthenticatedApp = hasUserInfo && !isOAuthCallbackInProgress();

  return (
    <Suspense fallback={<Loading type="mlb" />}>
      <BrowserRouter>{showAuthenticatedApp ? <AuthenticatedApp /> : <UnauthenticatedApp />}</BrowserRouter>
    </Suspense>
  );
};

export default App;
